(function(){
  var UPDATE_EVENTS = [
    'cart:updated','cart:refresh','cart:change',
    'ajaxProduct:added','theme:cart-drawer:open','cart-drawer:updated',
    'archetype:cart:updated','archetype:cart:change',
    'shopify:section:load','shopify:section:select','shopify:section:reorder'
  ];

  function formatMoney(cents, currency){
    try { return (cents/100).toLocaleString(undefined, { style:'currency', currency: currency || window.Shopify?.currency || 'EUR' }); }
    catch(e){ return (cents/100).toFixed(2) + ' ' + (currency || window.Shopify?.currency || 'EUR'); }
  }

  function renderOne(el, cart){
    var threshold = parseInt(el.getAttribute('data-threshold-cents'), 10) || 10000; // default €100
    var subtotal  = (cart && typeof cart.items_subtotal_price === 'number') ? cart.items_subtotal_price : 0;
    var remaining = threshold - subtotal;

    var textEl = el.querySelector('.ca-free-ship__text');
    var fillEl = el.querySelector('.ca-free-ship__bar-fill');

    var successText = textEl?.dataset.textSuccess || "🎉 You’ve unlocked free shipping!";
    var remainingTemplate = textEl?.dataset.textRemaining || "Spend {{ amount }} more to get free shipping";

    if (remaining <= 0){
      el.classList.add('ca-free-ship--success');
      if (textEl) textEl.textContent = successText;
      if (fillEl) fillEl.style.width = '100%';
    } else {
      el.classList.remove('ca-free-ship--success');
      var formatted = formatMoney(remaining, (cart && cart.currency) || undefined);
      if (textEl) textEl.textContent = remainingTemplate.replace('{{ amount }}', formatted);
      var pct = Math.max(0, Math.min(100, (subtotal / threshold) * 100));
      if (fillEl) fillEl.style.width = pct.toFixed(2) + '%';
    }
  }

  function renderAll(cart){
    document.querySelectorAll('.ca-free-ship').forEach(function(el){ renderOne(el, cart); });
  }

  function update(){
    fetch('/cart.js')
      .then(function(r){ return r.json(); })
      .then(function(cart){ renderAll(cart); })
      .catch(function(){});
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', update);
  } else {
    update();
  }

  UPDATE_EVENTS.forEach(function(evt){ document.addEventListener(evt, update); });

  document.addEventListener('click', function(e){
    var t = e.target;
    if (!t) return;
    if (t.closest && t.closest('.quantity__button')) update();
    if (t.matches && t.matches('[href*="change?line="]')) update();
    if (t.closest && t.closest('cart-remove-button')) update();
  }, true);

  document.addEventListener('change', function(e){
    var t = e.target;
    if (t && t.classList && t.classList.contains('quantity__input')) update();
  }, true);

  try {
    var target =
      document.querySelector('#main-cart-footer') ||
      document.querySelector('#main-cart-items') ||
      document.querySelector('.cart__items');
    if (target) {
      var mo = new MutationObserver(function(){ update(); });
      mo.observe(target, { childList:true, characterData:true, subtree:true });
    }
  } catch(e){}
})();
